export const CENTER_DELETE = 'testlist_delete'; // 测评中心列表—删除
export const REPORT_VIEW = 'testlist_classcomparisonreport'; // 测评中心列表—班级对比报告
export const RECORD_DELETE = 'previewlist_delete'; // 备课中心—预习记录—删除
export const LESSON_PREPARATION = 'homepage_lessonpreparation'; // 首页—进入备课中心
export const PRECISION_TEST = 'homepage_precisiontest'; // 首页—进入精准测评
export const LEARNING_TEACHER = 'homepage_intelligentadaptivelearningteacher'; // 首页—进入智适应教师端
export const COURSE_TEACHER = 'homepage_coursesupervisionteacher'; // 首页—老师—进入实时堂控系统
export const COURSE_HEADMASTER = 'homepage_coursesupervisionheadmaster'; // 首页—校长—进入实时堂控系统
export const EXERCISE_CENTER = 'homepage_exercise-center'; // 首页—进入练习中心
export const CLASS_ANALYSIS = 'homepage_class-analysis'; // 首页—进入学情分析
